interface SiteChromeOptions {
  title?: string;
  description?: string;
  image?: string;
  iconHref?: string;
  gaTagScript?: string;
}

function ensureMeta(
  attribute: "name" | "property",
  key: string,
  content: string,
): void {
  let el = document.head.querySelector(
    `meta[${attribute}="${key}"]`,
  ) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attribute, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function ensureLink(rel: string, href: string): void {
  let el = document.head.querySelector(
    `link[rel="${rel}"]`,
  ) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}

function syncGaTag(script: string | undefined): void {
  document.head
    .querySelectorAll('script[data-wedding-ga="1"]')
    .forEach((node) => node.remove());
  if (!script?.trim()) return;

  const template = document.createElement("template");
  template.innerHTML = script.trim();
  for (const node of Array.from(template.content.childNodes)) {
    if (node instanceof HTMLScriptElement) {
      node.dataset.weddingGa = "1";
    }
    document.head.appendChild(node);
  }
}

export function syncSiteChrome({
  title,
  description,
  image,
  iconHref,
  gaTagScript,
}: SiteChromeOptions): void {
  if (typeof document === "undefined") return;

  if (title) document.title = title;

  ensureMeta("name", "description", description || title || "Wedding");
  ensureMeta("property", "og:title", title || "Wedding");
  ensureMeta("property", "og:description", description || title || "Wedding");
  ensureMeta("property", "og:type", "website");
  ensureMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
  ensureMeta("name", "twitter:title", title || "Wedding");
  ensureMeta("name", "twitter:description", description || title || "Wedding");

  if (image) {
    ensureMeta("property", "og:image", image);
    ensureMeta("name", "twitter:image", image);
  }

  if (iconHref) {
    ensureLink("icon", iconHref);
    ensureLink("apple-touch-icon", iconHref);
  }

  syncGaTag(gaTagScript);
}
